import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
  reloadStatus: {
    data: {},
    timestamp: null,
  },
  loadGuiBootstarp: {
    data: {},
    timestamp: null,
  },
  loadOrgBootstarp: {
    data: {},
    timestamp: null,
  },
  loadTargetSite: {
    data: {},
    timestamp: null,
  }
};

const fetchStatusSlice = createSlice({
  name: 'fetchStatus',
  initialState,
  reducers: {
    cleanAll (state) {
      Object.assign(state, initialState);
    },
    setLoadGuiBootstarp (state, action) {
      state.loadGuiBootstarp.timestamp = action.payload;
    },
    setLoadOrgBootstarp (state, action) {
      state.loadOrgBootstarp = action.payload;
    },
    setReloadStatus (state, action) {
      state.reloadStatus = action.payload;
    },
    setTargetSite (state, action) {
      state.loadTargetSite = action.payload;
    },
  },
  extraReducers: {
  }
});


// for org, tag, site user reload Bootstarp
export const loadGuiBootstarp = () => {
  return async (dispatch) => {
    dispatch(fetchStatusActions.setLoadGuiBootstarp(new Date().getTime()));
  };
};

// for sp, si user load specify org.
// reloadGui: load gui & specify org Bootstarp at same time.
export const loadOrgBootstarp = (orgId, reloadGui) => {
  return async (dispatch) => {
    const obj = {
      data: {
        orgId,
        reloadGui,
      },
      timestamp: new Date().getTime()
    };
    dispatch(fetchStatusActions.setLoadOrgBootstarp(obj));
  };
};

export const reloadStatus = (state) => {
  return async (dispatch) => {
    const params = {
      data: {
        reloadState: state
      },
      timestamp: new Date().getTime() // update
    };
    dispatch(fetchStatusActions.setReloadStatus(params));
  };
};

export const loadTargetSite = ({ id, type }) => {
  return async (dispatch) => {
    const params = {
      data: {
        id,
        type
        // forceReload, ???
      },
      timestamp: new Date().getTime()
    };
    dispatch(fetchStatusActions.setTargetSite(params));
  };
};

export const fetchStatusActions = fetchStatusSlice.actions;

export default fetchStatusSlice;